import { NotFoundError } from '../apiErrors';
import { createApiResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { ServiceTitanMappedCall } from '../apiTypes.shim';

interface ServiceTitanMappedCallResource {
  getMappedCallOrNull: (callerId: string) => Promise<ServiceTitanMappedCall | null>;
}

export const createServiceTitanMappedCalls = (companyId: string): ServiceTitanMappedCallResource => {
  const mappedCallUri = `${companyId}/call-by-caller-id`;
  const { getById } = createApiResource(ServiceTitanAPI, mappedCallUri);

  const getMappedCallOrNull = async (callerId: string): Promise<ServiceTitanMappedCall | null> => {
    try {
      return await getById({
        id: callerId,
        extraOptions: { disableSnackOnNotFoundError: true },
        disableErrorReporting: true
      });
    } catch (err) {
      if (err instanceof NotFoundError) return null;
      throw err;
    }
  };

  return { getMappedCallOrNull };
};
